import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logout from '../svg/Logout';
import envVariable, { getExtranetLoginUrl } from "../../util/envVariable";
import RoleSwitcher from './RoleSwitcher';
import Share from '../svg/Share';
import { useEffect, useState } from 'react';

const HeaderLightComponent = (): JSX.Element => {
  const { t } = useTranslation()
  const logo = `${envVariable('REACT_APP_API_HOST')}/theme/images/logo.png`;
  const [isScrolled, setIsScrolled] = useState(false);

  const extranetUrl = getExtranetLoginUrl()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`header-wrapper ${isScrolled ? 'scrolled' : ''}`}>
      <div className="main-header u-mxl">
        <div className="flex-container middle-xs no-compensation">
          <h1 className="u-mb0 u-mrl">
            <a href="#">
              <img src={logo} alt="Société d'investissement" style={{ maxWidth: '150px' }} />
            </a>
          </h1>
        </div>

        <div className="flex-container middle-xs center-xs latest-item gap-4">
          <RoleSwitcher />
          <div className="flex-container middle-xs end-xs u-mrs">
            {extranetUrl &&
              <a href={extranetUrl} target="_blank" className="button btn-extranet-redirect button--medium button--width-fit u-pxs">
                <Share />
                <span className="text-logout">{t('button.extranet-redirect')}</span>
              </a>
            }
          </div>
          <div className="flex-container middle-xs end-xs">
            <Link to="/logout" className="button button-secondary button--medium button--logout button--width-fit u-pxs">
              <span className="text-logout">{t('button.logout')}</span>
              <Logout />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderLightComponent;
